import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login as apiLogin } from '../services/auth';
import { PageHeader } from '../ui/PageHeader';

export default function PartnerLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await apiLogin(email, password);
      navigate('/partner', { replace: true });
    } catch (err: any) {
      setError(err?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="page login-page">
      <PageHeader
        kicker="Verified Partners"
        title="Partner Login"
        subtitle="For vetted tour operators and community guides in the SafariCo Hub network."
      />

      <div style={{ maxWidth: 400, margin: '32px auto' }}>
        <form onSubmit={handleSubmit}>
          <label>
            Email
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </label>

          <label>
            Password
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </label>

          <button type="submit" disabled={loading} className="btn btnPrimary" style={{ width: '100%' }}>
            {loading ? 'Logging in…' : 'Login as Partner'}
          </button>
          {error && <div className="error" style={{ marginTop: 12 }}>{error}</div>}
        </form>

        <p className="muted" style={{ marginTop: 18, textAlign: 'center' }}>
          Not yet verified? <a href="/partner/apply">Apply to join the network</a>
        </p>
      </div>
    </div>
  );
}
